import produce from "immer"
import type { Reducer } from "redux"
import { ChapterZone } from "../../models/models"
import type { PagingActions, PagingOptions } from "../../models/types"
import { loadPagingOptions } from "../../utils/sort-table.utils"
import {
  LINKCHAPTER_LOAD,
  LINKCHAPTER_LOAD_DEFAULT,
  LINKCHAPTER_LOAD_LIST,
  LINKCHAPTER_LOAD_LIST_OPTIONS
} from "./linkchapter.actions"
import type { ILinkChapterState, LinkChapter, LinkChapterActions } from "./linkchapter.types"

const chapterInitialState: ILinkChapterState = {
  linkChapters: [],
  linkChapter: getEmptyLinkChapter(),
  pagingOptions: {
    currentPage: 0,
    pageSize: 10,
    totalPages: 0
  }
}

export const linkChapterReducer: Reducer<ILinkChapterState, LinkChapterActions | PagingActions> = (
  currentState,
  action
) => {
  const state = currentState ?? chapterInitialState
  switch (action.type) {
    case LINKCHAPTER_LOAD_DEFAULT: {
      return loadLinkChapter(state, getEmptyLinkChapter())
    }
    case LINKCHAPTER_LOAD_LIST: {
      return loadChapterList(state, action.payload as LinkChapter[])
    }
    case LINKCHAPTER_LOAD: {
      return loadLinkChapter(state, action.payload as LinkChapter)
    }
    case LINKCHAPTER_LOAD_LIST_OPTIONS: {
      return loadPagingOptions(state, action.payload as PagingOptions)
    }
    default: {
      return state
    }
  }
}

function loadChapterList(currentState: ILinkChapterState, chapters: LinkChapter[]): ILinkChapterState {
  return produce(currentState, (draftState: ILinkChapterState) => {
    draftState.linkChapters = chapters
  })
}

function loadLinkChapter(currentState: ILinkChapterState, linkChapter: LinkChapter): ILinkChapterState {
  return produce(currentState, (draftState: ILinkChapterState) => {
    draftState.linkChapter = linkChapter
  })
}

function getEmptyLinkChapter(): LinkChapter {
  return {
    name: "",
    thumbnailUrl: "",
    url: "",
    order: 0,
    zone: ChapterZone.BOTTOM,
    licenceIds: []
  }
}
